import { render, staticRenderFns } from "./QuestionItem.vue?vue&type=template&id=911a1b04&lang=true&"
import script from "./QuestionItem.vue?vue&type=script&lang=js&"
export * from "./QuestionItem.vue?vue&type=script&lang=js&"
import style0 from "./QuestionItem.vue?vue&type=style&index=0&id=911a1b04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports